module.exports = __webpack_public_path__ + "static/media/qaida.b9cbbbe2.png";